/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
  <div class="team-chunk">
    <div class="header">
      <h1>{{$t("about.honor")}}</h1>
      <el-button
        class="more-bnt"
        type="text"
        v-if="total>4"
        plain
        size="mini"
        @click="onMore"
      >{{$t("fromData.more")}}></el-button>
    </div>
    <div class="content-wrap">
      <div class="desc-wrap" v-for="item in leaderList" @click="onClick(item)">
        <div class="img cell">
          <img :src="item.icon">
          <span class="note"></span>
        </div>
        <p class="leader">
          <span>{{item.honorName}}</span>
        </p>
        <div class="cell"></div>
        <p class="desc"><span>{{item.department ?item.department: ''}}</span><span v-html="item.introduction"></span></p>
      </div>
    </div>
    <HonorDetailModal v-model="isShow" :teamDetail="teamDetail"></HonorDetailModal>
  </div>
</template>

<script>
import { GetHonorList } from '../../../api/web';
import HonorDetailModal from './honor-detail-modal'

export default {
  name: "team-chunk",
  components: { HonorDetailModal },
  data() {
    return {
      leaderList: [],
      isShow: false,
      teamDetail: {},
      total: 0,
    }
  },
  methods: {
    init() {
      let _params = {
        companyId: 2,
        pageNum: 1,
        pageSize: 4
      };
      GetHonorList(_params).then(res => {
        if (res.status) {
          this.leaderList = res.data.dataList;
          this.total = res.data.total;
        }
      })
    },
    onClick(item) {
      this.isShow = true;
      this.teamDetail = item
    },
		onMore(id) {
			this.$router.push({ name: 'HONOR' })
		},
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import "../../../style/constant";

.team-chunk {
  margin: 0 auto;
  width: @page-width;
  padding: 100px 0;

  .header {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .more-bnt {
    color: @title-info-color;
    align-self: center;
    position: relative;
  }
  .content-wrap {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;

    .desc-wrap {
      width: 300px;
      height: 260px;
      overflow: hidden;
      // text-align: center;
      background: #fbfbfb;
      display: flex;
      flex-wrap: wrap;
      .cell {
        width: 128px;
        height: 128px;
      }
      img {
        cursor: pointer;
        object-fit: cover;
      }
      .img {
        position: relative;
        .note {
          width: 28px;
          height: 28px;
          background: #394f9a;
          position: absolute;
          right: 0px;
          bottom: 0px;
        }
      }
      .leader {
        width: 172px;
        color: #435ba1;
        position: relative;
        span {
          position: absolute;
          left: 10px;
          bottom: 0;
        }
      }
      @media screen and (min-width: 320px) and (max-width: 480px) {
        .leader {
          width: 190px;
        }
      }
      .desc {
        width: 162px;
        font-size: 15px;
        padding: 10px 0 0 10px;
        span {
          display: block;
        }
      }
      &:hover {
        background: #f2f3f5;
        .note {
          background: #e76c5e;
        }
      }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      .desc-wrap {
        height: 260px;
        width: 100%;
        .desc {
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .team-chunk {
    width: 90%;
    padding: 60px 0;
    .content-wrap {
      margin: 0px auto;
      padding: 10px 0;
    }
  }
}
</style>